


import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, Timeline, TweenLite} from "gsap";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {HarlequinReelSymbol} from "../../symbols/HarlequinReelSymbol";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";

export class HarlequinAddFreespinView extends BaseView {

    private _plusOneOverlays:PIXI.Sprite [][] = [];
    private _plusOneSpines:PIXI.spine.Spine [][] = [];
    private _layer:ScalableLayer;

    private _activePlusOneTimelines:Timeline [] = [];

    constructor() {
        super();

        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.PLUS_ONE.name);
        this._layer.addChild(this);
    }

    initAnimations() {
        this._plusOneOverlays = this.createSpineOverlays();
    }


    protected createSpineOverlays(): PIXI.Sprite [][] {
        const gridArr: PIXI.Sprite [][] = [];
        const gridSpineArr: PIXI.spine.Spine [][] = [];

        [0,1,2,3,4].forEach((reelId) => {
            const symArr: PIXI.Sprite [] = [];
            const spineArr: PIXI.spine.Spine [] = [];

            //const rArr: PIXI.spine.Spine [][] = [];

            [0,1,2].forEach((symId) => {
                const sprite:PIXI.Sprite = new PIXI.Sprite();
                sprite.name = "r" + reelId + "_s" + symId;
                sprite.visible = false;

                const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterWildSpine"));
                spine.autoUpdate = true;
                spine.name = "spine_" + "r" + reelId + "_s" + symId;

                const position: number [] = Helper.getSymbolPositions(reelId, symId);
                sprite.position.set(position[0], position[1]);
                //spine.anchor.set(0.5, 0.5);
                sprite.addChild(spine);
                this.addChild(sprite);

                symArr.push(sprite);
                spineArr.push(spine);
            });

            gridArr.push(symArr);
            gridSpineArr.push(spineArr);
        });

        //console.log("PLUS FS OVERLAYS");
        //console.log(gridArr);
        //console.log(gridSpineArr);

        this._plusOneSpines = gridSpineArr;

        /*this._plusOneSpines.forEach((reelArr, rindex) => {
            reelArr.forEach((symArr, sindex) => {
                console.log(this._plusOneSpines[rindex][sindex].skeleton.data.animations);
                this._plusOneSpines[rindex][sindex].state.setAnimation(0, "+1spin", true);
            });
        });*/
        return gridArr;
    }

    public showAndPlayPlusOneSpine(reelId:number, symId:number, animName:string = "+1spin", loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry) => void, aborted:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineLite();
        //console.log(spine.skeleton.data.animations);

        if(this._plusOneOverlays[reelId][symId] && this._plusOneSpines[reelId][symId].state.hasAnimation(animName)) {
           //const spine:PIXI.spine.Spine = this._plusOneSpines[reelId][symId];

            const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterWildSpine"));
            spine.autoUpdate = true;
            spine.name = "spine_" + "r" + reelId + "_s" + symId;
            this._plusOneOverlays[reelId][symId].removeChild(this._plusOneSpines[reelId][symId]);
            this._plusOneSpines[reelId][symId] = spine;
            this._plusOneOverlays[reelId][symId].addChild(this._plusOneSpines[reelId][symId]);
            //this._plusOneSpines[reelId][symId].state.setEmptyAnimation(0,0);
            //this._plusOneSpines[reelId][symId].skeleton.setToSetupPose();
            //this._plusOneSpines[reelId][symId].state.tracks = [];

            tl.add(() => {
                if(!aborted) {
                    this._plusOneOverlays[reelId][symId].visible = true;
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_PLUS);
                    this._plusOneSpines[reelId][symId].state.setAnimation(0, animName, loop);
                }
            });
            const dur:number = this._plusOneSpines[reelId][symId].skeleton.data.animations[0].duration || 0.5;
            tl.add(() => {
                new TimelineLite().add(() => {
                    this._plusOneOverlays[reelId][symId].visible = false;
                }, dur);
                //this._plusOneSpines[reelId][symId].state.setEmptyAnimation(0,0);
            }, "+=" + (dur - 1.5));


                //tl.add(
            const func: (entry:PIXI.spine.core.TrackEntry) => void = (entry:PIXI.spine.core.TrackEntry) => {
                //debugger;
                if(entry.animation.name === animName) {
                    this._plusOneOverlays[reelId][symId].visible = false;
                    //this._plusOneSpines[reelId][symId].state.setEmptyAnimation(0,0);
                }

                if(onComplete) {
                    onComplete(entry);
                }

                //this._plusOneSpines[reelId][symId].state.r;
            };


                    /*this._plusOneSpines[reelId][symId].state.addListener({
                        //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                        end: func
                        //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                        //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
                    });*/

        }

        return tl;
    }

    public resetPlusOneSpines():void {
        this._plusOneSpines.forEach((symArr, rindex) => {
            symArr.forEach((sym) => {
                //sym.state.setEmptyAnimation(0,0);
            })
        });

        this._plusOneOverlays.forEach((spriteArr, rindex) => {
            spriteArr.forEach((sprite) => {
                sprite.visible = false;
            })
        });
    }


    public createPlusOneForPos(reelId:number, symId:number, aborted:boolean = false):Timeline {
        return this.showAndPlayPlusOneSpine(reelId, symId, undefined, undefined, undefined, aborted);
    }



    onResize(resizeData:IResizeData) {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this.scale.set(1, 1);
            this.position.set(-280, -185);
        }
        else {
            this.position.set(-210, -35);
            this.scale.set(0.87, 0.87);
        }

    }

}